export const CLIENTS_SUMMARY_LIST = 'CLIENTS_SUMMARY_LIST';
export const SET_CLIENT_SUMMARY_LOADING = 'SET_CLIENT_SUMMARY_LOADING';
export const CLIENTS_SUMMARY_LIST_FETCH_FAILED = 'CLIENTS_SUMMARY_LIST_FETCH_FAILED';
export const CLIENTS_SUMMARY_NO_RECORD_FOUND = 'CLIENTS_SUMMARY_NO_RECORD_FOUND';

export const CLICKED_ROW_SUMMARY = 'CLICKED_ROW_SUMMARY';

export const CLIENTS_STATEMENT_FETCH_FAILED = 'CLIENTS_STATEMENT_FETCH_FAILED';

export const YTD_SUMMARY = 'YTD_SUMMARY';

export const RESET_CLIENTS_SUMMARY = 'RESET_CLIENTS_SUMMARY';

export const CLIENTS_SUMMARY_DASHBOARD = 'CLIENTS_SUMMARY_DASHBOARD';

export const CLIENTS_SUMMARY_DASHBOARD_FETCH_FAILED = 'CLIENTS_SUMMARY_DASHBOARD_FETCH_FAILED';

export const SHOW_PAGINATION_PROGRESS = 'SHOW_PAGINATION_PROGRESS';

export const AUTO_SUGGEST_SEARCH_SUCCESS = 'AUTO_SUGGEST_SEARCH_SUCCESS';
export const AUTO_SUGGEST_SEARCH_FAILED = 'AUTO_SUGGEST_SEARCH_FAILED';

// Clients New Action

export const REQUEST_CLIENTS_DATA = 'REQUEST_CLIENTS_DATA';
export const RECEIVE_CLIENTS_DATA = 'RECEIVE_CLIENTS_DATA';
export const CLIENTS_SERVICE_ERROR = 'CLIENTS_SERVICE_ERROR';
export const CLIENTS_SET_PAGE_NUMBER = 'SET_PAGE_NUMBER';
export const SET_CLIENTS_SEARCH_DETAILS = 'SET_CLIENTS_SEARCH_DETAILS';
export const CONCAT_CLIENTS_DATA = 'CONCAT_CLIENTS_DATA';
export const SET_CLIENTS_REST_PROPS = 'SET_CLIENTS_REST_PROPS';
